import { useState, useRef, useEffect } from "react";
import { useLanguage } from "../i18n/language.context";
import { translations, type Lang } from "../i18n/translations";
import "./languageDropdown.component.css";

const FLAGS: Record<Lang, string> = { en: "gb", es: "es", pt: "pt", de: "de" };
const ORDER: Lang[] = ["en", "es", "pt", "de"];
const flagUrl = (code: string) => `https://flagcdn.com/${code}.svg`;

function LanguageDropdown() {
    const { lang, setLang, t } = useLanguage();
    const [open, setOpen] = useState(false);
    const ref = useRef<HTMLDivElement>(null);

    // Klick außerhalb schließt das Menü.
    useEffect(() => {
        function onDocClick(e: MouseEvent) {
            if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
        }
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, []);

    return (
        <div className="lang-dd" ref={ref}>
            <button
                className={`lang-dd-trigger ${open ? "open" : ""}`}
                onClick={() => setOpen((o) => !o)}
                aria-haspopup="listbox"
                aria-expanded={open}
                aria-label={t("ui.language")}
            >
                <img className="lang-dd-flag" src={flagUrl(FLAGS[lang])} alt="" />
                {open && <span className="lang-dd-label">{t("ui.language")}</span>}
                <span className={`lang-dd-caret ${open ? "up" : ""}`} aria-hidden="true">▾</span>
            </button>

            {open && (
                <ul className="lang-dd-menu" role="listbox">
                    {ORDER.map((code) => (
                        <li key={code}>
                            <button
                                className={`lang-dd-option ${lang === code ? "active" : ""}`}
                                onClick={() => { setLang(code); setOpen(false); }}
                                role="option"
                                aria-selected={lang === code}
                            >
                                <img className="lang-dd-flag" src={flagUrl(FLAGS[code])} alt="" />
                                <span>{translations[code]["lang.name"]}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

export default LanguageDropdown;
